const defaults = {
  cartModal: '.js-ajax-cart-modal', // classname
  cartModalContent: '.js-ajax-cart-modal-content', // classname
  cartModalClose: '.js-ajax-cart-modal-close', // classname
  cartDrawer: '.js-ajax-cart-drawer', // classname
  cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
  cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
  cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
  cartOverlay: '.js-ajax-cart-overlay', // classname
  cartCounter: '.js-ajax-cart-counter', // classname
  addToCart: '.js-ajax-add-to-cart', // classname
  removeFromCart: '.js-ajax-remove-from-cart', //classname
  removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
  checkoutButton: '.js-ajax-checkout-button',
  cartFooterButton: '.js-ajax-cart-drawer__footer'
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartModalClose = document.querySelector(defaults.cartModalClose);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;
const cartFooterButton = document.querySelector(defaults.cartFooterButton);

for (let i = 0; i < addToCart.length; i++) {

  addToCart[i].addEventListener('click', function(event) {

    event.preventDefault();
    const formID = $(this).parents('form').attr('id');
    console.log(formID);

    addProductToCart(formID);

  });

}

function addProductToCart(formID) {
  console.log(formID);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: $('#' + formID)
    .serialize(),
    success: addToCartOk,
    error: addToCartFail,
  });
}

function fetchCart() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      onCartUpdate(cart);

      if (cart.item_count === 0) {
        cartFooterButton.classList.add('is-hidden');
        cartDrawerContent.innerHTML = 'Cart is empty';
        checkoutButton.classList.add('is-hidden');
      } else {
        renderCart(cart);
        cartFooterButton.classList.remove('is-hidden');
        checkoutButton.classList.remove('is-hidden');
      }

    },
  });
}

function changeItem(line, callback) {
  const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart();
      }
    },
  });
}

function updateItem(line, quantity, callback) {
  //const quantity = 0;
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart();
        removeProductFromCart(cart);
      }
    },
  });
}

function onCartUpdate(cart) {
  console.log('items in the cart?', cart.item_count);
  
  if(cart.item_count == 0){
    //$('.js-ajax-cart-drawer-trigger .cart-count-bubble').remove();
    //$('.ajax-cart-drawer').addClass('empty-cart');
    
    var h = `<img src="//cdn.shopify.com/s/files/1/1762/3593/t/6/assets/cart_ic.png?v=11947254317577588782"/><span class="visually-hidden">Cart</span>`;
      
    $('.js-ajax-cart-drawer-trigger').html(h);
    
  }else{
    if($('.js-ajax-cart-drawer-trigger .cart-count-bubble').length > 0){
      //$('.js-ajax-cart-counter').innerHTML = cart.item_count;
      $('.js-ajax-cart-counter').html(cart.item_count);
      //console.log(cart.item_count);
    }else{
      var h = `<img src="//cdn.shopify.com/s/files/1/1762/3593/t/6/assets/cart_ic.png?v=11947254317577588782"/>
      <span class="visually-hidden">Cart</span>
      <div class="cart-count-bubble">
      <span aria-hidden="true" class="js-ajax-cart-counter">`+cart.item_count+`</span>
      <span class="visually-hidden">`+cart.item_count+` item</span>
      </div>`;
      
      $('.js-ajax-cart-drawer-trigger').html(h);
    }
  }
}

function addToCartOk(product) {
  //cartModalContent.innerHTML = product.title + ' was added to the cart!';
  //cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
  //openAddModal();
  //openCartOverlay();
  fetchCart();
  cartDrawer.classList.add('is-open');
}

function removeProductFromCart() {
  cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
  cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
  openAddModal();
  openCartOverlay();
}

function renderCart(cart) {
  
  console.log(cart);

  clearCartDrawer();

  cart.items.forEach(function(item, index) {

    //console.log(item.title);
    //console.log(item.image);
    //console.log(item.line_price);
    //console.log(item.quantity);

    const productTitle = '<div class="ajax-cart-item__title">' + item.title + '</div>';
    const productImage = '<img class="ajax-cart-item__image" src="' + item.image + '" >';
    const productPrice = '<div class="ajax-cart-item__price">' + Shopify.formatMoney(item.final_price) + '</div>';
    //const productQuantity = '<div class="ajax-cart-item__quantity">' + item.quantity + '</div>';
    const productRemove = '<div class="ajax-cart-item__remove ' + defaults.removeFromCartNoDot + '"></div>';
    
    const productQuantity = '<div class="ajax-cart-item__quantity"><quantity-input class="quantity" data-line="' + Number(index + 1) + '">'+
      '<button class="quantity__button no-js-hidden js-ajax-cart-minus" name="minus" type="button">-</button>'+
      '<input class="quantity__input js-ajax-item__quantity" type="number" name="updates[]" id="Quantity-'+index+'" value="'+item.quantity+'" form="ajax-cart-item__quantity'+index+'">'+
      '<button class="quantity__button no-js-hidden js-ajax-cart-plus" name="plus" type="button">+</button></div>'+
      '</quantity-input>';

    const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '"><div class="ajax_pro_img"><a href="'+item.url+'">' + productImage +'</a></div><div class="ajax_pro_info"><a href="'+item.url+'">' + productTitle +'</a>'+ productPrice + productQuantity + productRemove + '</div></div>';

    cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

  });

  var removeFromCart = document.querySelectorAll(defaults.removeFromCart);
  var updateCart = document.querySelectorAll('.js-ajax-item__quantity');

  for (let i = 0; i < removeFromCart.length; i++) {
    removeFromCart[i].addEventListener('click', function() {
      const line = this.parentNode.getAttribute('data-line');
      console.log(line);
      changeItem(line);
    });
  }
  
  for (let i = 0; i < updateCart.length; i++) {
    updateCart[i].addEventListener('change', function() {
      const line = this.parentNode.getAttribute('data-line');
      const val = this.value;
      updateItem(line, val);
    });
  }

}

function openCartDrawer() {
  cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
  cartDrawerContent.innerHTML = '';
}

function openAddModal() {
  cartModal.classList.add('is-open');
}

function closeAddModal() {
  cartModal.classList.remove('is-open');
}

function openCartOverlay() {
  cartOverlay.classList.add('is-open');
  htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
  cartOverlay.classList.remove('is-open');
  htmlSelector.classList.remove('is-locked');
}

cartModalClose.addEventListener('click', function() {
  closeAddModal();
  closeCartOverlay();
});

cartDrawerClose.addEventListener('click', function() {
  closeCartDrawer();
  closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
  closeAddModal();
  closeCartDrawer();
  closeCartOverlay();
});

cartDrawerTrigger.addEventListener('click', function(event) {
  event.preventDefault();
  fetchCart();
  openCartDrawer();
  openCartOverlay();
});

document.addEventListener('DOMContentLoaded', function() {
  fetchCart();
});